import RUF from "../../../util/redux";

export function modelSetLoanGuid(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      guid: action.payload
    })
  });
}
